import { render, staticRenderFns } from "./IntoStockList.vue?vue&type=template&id=cfb5f4a6&scoped=true&"
import script from "./IntoStockList.vue?vue&type=script&lang=js&"
export * from "./IntoStockList.vue?vue&type=script&lang=js&"
import style0 from "./IntoStockList.vue?vue&type=style&index=0&id=cfb5f4a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb5f4a6",
  null
  
)

export default component.exports